import type { Middleware, UnknownAction } from 'redux';
import Reporter from 'utils/crash-reporting/crashReporter';

type AuthStateChangedAction = UnknownAction & {
  type: 'AUTH_STATE_CHANGED';
  payload?: {
    uid?: string;
    email?: string;
  };
};

export const middleware: Middleware = () => {
  return (next) => {
    return (action: UnknownAction) => {
      switch (action.type) {
        case 'AUTH_STATE_CHANGED': {
          const payload = (action as AuthStateChangedAction).payload || {};
          Reporter.setUser({
            id: payload.uid,
            email: payload.email,
          });
          break;
        }
        default:
          break;
      }
      return next(action);
    };
  };
};

export default middleware;
